import React from 'react';
import SimpleModal from '@teetsh/app/src/components/SimpleModal';
import { TrashIcon as Trash } from '@heroicons/react/24/outline';
import useDeleteEleves from '@teetsh/app/src/queries/eleves/useDeleteEleves';
import { Eleve } from '@teetsh/app/src/types/eleves';
import { useTranslation } from 'react-i18next';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  eleves: Eleve[];
}

export function DeleteElevesWarningModal(props: Props) {
  const { eleves, onClose, isOpen } = props;
  const deleteEleves = useDeleteEleves();
  const { t } = useTranslation(['eleve']);
  return (
    <SimpleModal
      isOpen={isOpen}
      title={t('eleve:deleteAllElevesWarning')}
      buttonIcon={Trash}
      body={`Il y a ${eleves.length} élève${
        eleves.length > 1 ? 's' : ''
      } à supprimer`}
      validateTitle={t('eleve:yesDeleteAllEleves')}
      validateAction={() => deleteEleves().then(onClose)}
      closeModalFct={() => onClose()}
    />
  );
}
